import { render, staticRenderFns } from "./MyTest.vue?vue&type=template&id=26f96217&scoped=true"
import script from "./MyTest.vue?vue&type=script&lang=js"
export * from "./MyTest.vue?vue&type=script&lang=js"
import style0 from "./MyTest.vue?vue&type=style&index=0&id=26f96217&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f96217",
  null
  
)

export default component.exports